<template>
  <VuePaginate
    :value="modelValue"
    :force-page="modelValue"
    :page-count="pageCount"
    :page-range="pageRange"
    :container-class="'ds-pagination' + className"
    :click-handler="paginationChange"
  />
</template>

<script>
import VuePaginate from './VuePaginate.vue';

export default {
  name: 'BasePagination',
  emits: ['change', 'input', 'update:modelValue'],

  components: { VuePaginate },

  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    pageRange: {
      type: Number,
      default: 3,
    },
    position: {
      type: String,
      validator: position => ['center', 'left'].includes(position),
      default: 'left',
    },
  },

  computed: {
    className() {
      if (this.position === 'center') {
        return ' flex justify-center';
      }
      return '';
    },
  },

  methods: {
    paginationChange(page) {
      this.$emit('input', page);
      this.$emit('change', page);
      this.$emit('update:modelValue', page);
    },
  },
};
</script>

<style scoped>

</style>
